<!--<mat-form-field class="full-width">
        <span matPrefix>
            <mat-icon>search</mat-icon>
        </span>
        <input matInput #filter placeholder="Buscar..." />
    </mat-form-field>-->

<div class="contenedor-tabla">
    <mat-table
        class="servicios-tabla"
        #table
        [dataSource]="dataSource"
        matSort
        matSortActive="fechaSolicitud"
        matSortDisableClear
        matSortDirection="desc"
        [@animateStagger]="{ value: '50' }"
        fusePerfectScrollbar
    >
        <ng-container matColumnDef="idsolicitudcotizacion">
            <mat-header-cell *matHeaderCellDef mat-sort-header
                >Nro Cotización</mat-header-cell
            >
            <mat-cell *matCellDef="let cotizacion">
                <p>
                    <a [routerLink]="'/cotizaciones/' + cotizacion.id">
                        {{ cotizacion.id }}
                    </a>
                </p>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="estado">
            <mat-header-cell *matHeaderCellDef>Estado</mat-header-cell>
            <mat-cell *matCellDef="let cotizacion">
                <p *ngIf="cotizacion.valor">
                    <strong>
                        Cotizada
                    </strong>
                </p>

                <p *ngIf="!cotizacion.valor">
                    <strong>
                        <span style="background-color: red;color: white;">Pendiente de Cotizar</span>
                    </strong>
                </p>


            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="cliente">
            <mat-header-cell *matHeaderCellDef>Cliente</mat-header-cell>
            <mat-cell *matCellDef="let cotizacion">
                <p>
                    {{ cotizacion.cliente.nombre }} <br />
                    <small>{{ cotizacion.cliente.rut }}</small>
                </p>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="fechaSolicitud">
            <mat-header-cell *matHeaderCellDef mat-sort-header
                >Fecha</mat-header-cell
            >
            <mat-cell *matCellDef="let cotizacion">
                <p>
                    {{ cotizacion.fecha | date: "dd-MM-yyyy" }}
                </p>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="valor">
            <mat-header-cell *matHeaderCellDef>Valor</mat-header-cell>
            <mat-cell *matCellDef="let cotizacion">
                <p>
                    {{ cotizacion.valor ? "UF " + cotizacion.valor : "-" }}
                </p>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="fechaVigencia">
            <mat-header-cell *matHeaderCellDef>Fecha vigencia</mat-header-cell>
            <mat-cell *matCellDef="let cotizacion">
                <p *ngIf="cotizacion.fechaVigencia">
                    <strong>{{
                        cotizacion.fechaVigencia | date: "dd-MM-YYYY HH:mm"
                    }}</strong>
                </p>
                <p *ngIf="!cotizacion.fechaVigencia">-</p>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="vigente">
            <mat-header-cell *matHeaderCellDef>Vigencia</mat-header-cell>
            <mat-cell *matCellDef="let cotizacion">
                <span
                    *ngIf="cotizacion.valor && cotizacion.vigente"
                    class="green-600 s-16 p-4"
                    >Vigente</span
                >
                <span
                    *ngIf="
                        cotizacion.valor &&
                        !cotizacion.vigente &&
                        cotizacion.fechaVigencia
                    "
                    class="red-500 s-16 p-4"
                    >No Vigente</span
                >

                <span
                    *ngIf="
                        cotizacion.valor &&
                        !cotizacion.vigente &&
                        !cotizacion.fechaVigencia
                    "
                    >Sin vigencia</span
                >

                <span *ngIf="!cotizacion.valor" class="s-16 p-4">-</span>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="acciones">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let cotizacion">
                <div *ngIf="cotizacion.valor && !cotizacion.vigente">
                    <button
                        *ngIf="_menuUsuarioSrvc.esEncargado()"
                        mat-button
                        type="button"
                        color="accent"
                        [disabled]="procesando"
                        (click)="solicitarActualizacion(cotizacion.id)"
                    >
                        Solicitar actualización
                    </button>
                    <button
                        *ngIf="_menuUsuarioSrvc.esSupervisor()"
                        mat-button
                        type="button"
                        color="accent"
                        (click)="actualizarVigencia(cotizacion.id)"
                    >
                        {{
                            !cotizacion.vigente && !cotizacion.fechaVigencia
                                ? "Enviar Cotización"
                                : "Actualizar y Enviar Cotización"
                        }}
                    </button>
                </div>
            </mat-cell>
        </ng-container>

        <mat-header-row
            *matHeaderRowDef="displayedColumns; sticky: true"
        ></mat-header-row>

        <mat-row *matRowDef="let cotizacion; columns: displayedColumns">
        </mat-row>
    </mat-table>
    <mat-paginator
        #paginator
        [length]="resultsLength"
        [pageIndex]="0"
        [pageSize]="10"
        [pageSizeOptions]="[5, 10, 25, 100]"
    >
    </mat-paginator>
</div>
<p *ngIf="dataSource.data.length === 0">No hay cotizaciones por el momento</p>
